module.exports = __webpack_public_path__ + "img/ecologic-web.64bfb463.png";